import styled from 'styled-components';

export const RowLine = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  margin-bottom: 10px;
`;
export const SpanBlock = styled.div``;
